import { useEffect, useSyncExternalStore } from 'react';

/**
 * How many overlays are open right now: modals, slide-overs, the notification panel, any
 * dropdown menu. The sidebar watches this so it can collapse the moment something opens on top
 * of it — a pointer that was over the rail when the overlay appeared would otherwise keep the
 * rail expanded underneath, with no further pointer event coming to close it.
 */
let count = 0;
const listeners = new Set<() => void>();

function emit(): void {
  for (const l of listeners) l();
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

/** Register an overlay for as long as `open` is true. */
export function useOverlay(open: boolean): void {
  useEffect(() => {
    if (!open) return;
    count++;
    emit();
    return () => {
      count--;
      emit();
    };
  }, [open]);
}

/** The number of overlays currently open. */
export function useOverlayCount(): number {
  return useSyncExternalStore(
    subscribe,
    () => count,
    () => 0,
  );
}
